export const apiConfigs = {
    baseURL : "https://api.ngkh.ir/v1/",
};
